<template>
  <div class="messageCenterdantuPage">
       <mu-appbar class="XR-head" :title="titleTextValue">
          <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
      </mu-appbar>
      <mu-list-item class="biaoti" :title="info.Title" :describeText="info.AddDate.replace('T',' ')">
         
      </mu-list-item>
      <!-- <div class="img">
          <img src="info" alt="">
      </div> -->
      <div class="row">
          <div v-html="info.ContentDetail"></div>
      </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>
<script>
export default {
  name : 'XR-head',
  data () {
    return {
      info:{},
      titleTextValue:''
    }
  },
  props:{
    titleText: String,
   
  },
  mounted(){
    this.getInformationDetail()
  },
  methods: {
    GoHistory(){
      this.$router.goBack()
    },    
    getInformationDetail(){
      var ths = this;   
      ths.$post(
        "/Shop/articleServer/GetInformationDetailImgText",{id: this.$route.query.id}
      ).then(function(res) {
        if(!res.IsSuccess){
        }else{          
          ths.info = res.Data;
          ths.info.ContentDetail = decodeURIComponent(ths.info.ContentDetail)
          ths.titleTextValue =res.Data.Title
          ths.loaded = false
          ths.$refs.XRtoast.hide()
        }
      });
    }
  }
}
</script>
<style>
body .messageCenterdantuPage {
  background: #fff;
}
.messageCenterdantuPage .XR-head .mu-appbar{
  height: 46px;
  text-align: center;
}
.messageCenterdantuPage .XR-head .mu-appbar.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.messageCenterdantuPage .XR-head .mu-appbar-title {
  font-size: 16px;
  padding-right: 48px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.messageCenterdantuPage .XR-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.messageCenterdantuPage .XR-head .title .title-text {
  margin: 0;
  line-height: 48px;
}
.messageCenterdantuPage .biaoti .mu-item .mu-item-title{
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  line-height: 24px;
}
.messageCenterdantuPage .biaoti .mu-item .mu-item-text{
  font-size: 12px;
  text-align: center;
}
.messageCenterdantuPage .img{
  width: 100%;
  position: relative;
  padding: 0 16px;
}
.messageCenterdantuPage .img .title{
   width: 100%;
   background: #000;
   color: #fff;
   display: flex;
   height: 30px;
   line-height: 30px;
   font-size: 12px;
   position: relative;
   bottom: 36px;
   opacity: 0.7;
}
.messageCenterdantuPage .img .title p{
  width: 80%;
  overflow: hidden;
  white-space: nowrap;
  padding-left:16px;
  text-overflow: ellipsis;
}
.messageCenterdantuPage .img .title span{
  text-align: right;
  padding-right: 16px;
  width:20%;
}
.messageCenterdantuPage .img img{
  width: 100%;
  height: 100%;
}
.messageCenterdantuPage .row{
  padding: 16px;
  }
.messageCenterdantuPage .row p{line-height: 30px;}

.messageCenterdantuPage .row img{
  display: block;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/informationDetail.vue